export const FRONTDESK_VIEW = "frontdesk.view";
export const FRONTDESK_MANAGE = "frontdesk.manage";
